<template>
  <div>
    <div class="d-flex align-center">
      <ProductYearDrop :yearOptions="yearOptions" :value="showYear" @input="(item) => $emit('setYearDisplay', item)" />

      <v-btn icon small @click="dialog = true">
        <v-icon small color="white">edit</v-icon>
      </v-btn>
    </div>

    <ProductYearDialog
      v-model="dialog"
      :showYear="showYear"
      :addNextYear="addNextYear"
      :addYearAfterNext="addYearAfterNext"
      :alreadyNextYearAdded="alreadyNextYearAdded"
      :alreadyYearAfterNextAdded="alreadyYearAfterNextAdded"
    />
  </div>
</template>

<script>
import ProductYearDrop from "./ProductYearDrop";
import ProductYearDialog from "./_ProductYearDialog";
export default {
  props: {
    showYear: String,
    yearOptions: Array,
    addNextYear: Function,
    addYearAfterNext: Function,
    missingNextYearRates: Boolean,
    missingYearAfterNextRates: Boolean,
  },
  components: {
    ProductYearDrop,
    ProductYearDialog,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    alreadyNextYearAdded() {
      return this.hasYearOffsetAdded(1, this.missingNextYearRates);
    },
    alreadyYearAfterNextAdded() {
      return this.hasYearOffsetAdded(2, this.missingYearAfterNextRates);
    },
  },
  methods: {
    hasYearOffsetAdded(offset, missingFlag) {
      if (missingFlag) return false;
      const currentYear = new Date().getFullYear();
      const targetYear = `${currentYear + offset}`;
      return this.yearOptions.includes(targetYear);
    },
  },
};
</script>

<style lang="scss">
.year-option {
  padding: 5px 15px;
  max-height: 30px;
  height: 30px;
  min-height: 30px;
}
</style>
